<template>
  <div>
    <div class="bg" :style="{background:dynamicColor.rgb}">
      <img class="bacColor" src="../../../static/images/logbg2.png" alt="">
      <div class="bg_con2">
        <div>
          <div>当前{{contributionRealName}}</div>
          <!--					<p>{{Intercept(dividendInformation.contribution)}}</p>-->
          <div>{{Number(dividendInformation.contribution).toFixed(1)}}</div>
        </div>
        <div>
          <div>
            <div style="display: flex; align-items: center">
              <span>冻结{{contributionRealName}}</span>
              <div style="position: relative; z-index: 10">
                <img class="infon" @click="infon" src="../../../static/images/info.png" alt=""/>
                <div class="popBg" v-if="Introduction">
                  <div>冻结{{contributionRealName}}在订单确认收货且售后期结束时解冻！</div>
                  <img src="../../../static/images/triangle.png" alt=""/>
                </div>
              </div>
            </div>

          </div>
          <!--					<p>{{Intercept(dividendInformation.frozenContribution)}}</p>-->
          <div>{{Number(dividendInformation.frozenContribution).toFixed(1)}}</div>
        </div>
        <div v-if="dividendInformation.leaderContributionIsOn == '1'">
          <div>
            <div style="display: flex; align-items: center">
              <span>领导者{{contributionRealName}}</span>
              <div style="position: relative; z-index: 10">
                <img class="infon" @click="infoLock" src="../../../static/images/info.png" alt=""/>
                <div class="popBg2" v-if="IntroductionLeaderLock">
                  <div>冻结中的领导者贡献!</div>
                  <img src="../../../static/images/triangle.png" alt=""/>
                </div>
              </div>
            </div>

          </div>
          <div>{{Number(dividendInformation.leaderFrozenContribution).toFixed(1)}}</div>
        </div>
      </div>
      <div class="raiders">
        <span>{{Introductions.contributionIntroduce}}</span>
        <span @click="riskCli" style="color: #ffffff">去做任务></span>
      </div>
      <div class="returnBut" @click="returnBut">
        <img src="../../../static/images/return_b.png" alt="">
        <p>返回</p>
      </div>
    </div>
    <div class="listWrap">
      <div class="list" v-for="(item,index) in list" v-if="list.length != 0">
        <h3>{{item.date}}</h3>
        <ul class="uls">
          <li v-for="(e,x) in item.value">
            <div class="ulsLiLeft">
              <p>{{e.name}}</p>
              <p>{{e.time}}</p>
            </div>
            <div class="ulsRight">
              <p :style="{color:e.status == '冻结中'?'#878787':''}">
                {{e.value}}
              </p>
              <p :style="{color:dynamicColor.rgb}">{{e.status}}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="load" v-if="pageStat" @click="pagesClick">加载更多</div>
      <div class="noData" v-if="list.length == 0">
        <img src="../../../static/images/empty.png" alt="">
        <p>暂无记录</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from "vant";
  import {Loading} from 'element-ui';
  import {Message} from 'element-ui';
  import cookie from "js-cookie";
  // var appid = localStorage.getItem("xq-appid");
  // var mobile = localStorage.getItem("xq-mobile");

  var mobile = cookie.get("xq-mobile");
  var appid = cookie.get("xq-appid");
  export default {
    name: "index",
    data() {
      return {
        tabStat: 0,
        apiName: '',
        list: [],
        dividendInformation: {
          contribution: 0,
          frozenContribution: 0,
          leaderFrozenContribution: 0,
          leaderContributionIsOn: '0'
        },
        dynamicColor: {},
        Introduction: false,
        IntroductionLeaderLock: false,
        Introductions: {},
        pageStat: true,
        pagesNum: 1,
        loadingInstance: null,
        bonusRealName: '分红',
        contributionRealName: '贡献'

      }
    },
    created() {
      this.dynamicColor = JSON.parse(localStorage.getItem('bakColor'));
      this.apiName = this.API1url.API;
      // this.dividendInformation = this.$store.state.userData == '{}'?this.$store.state.userData:JSON.parse(localStorage.getItem('userData'));

      this.$get(this.apiName.realNameData, { // 获取分红、贡献真名
        appid: appid,
        mobile: mobile
      }).then(res => {
        if (res.code == '0000') {
          // this.platformContribution = res.data;
          this.bonusRealName = res.data.bonusRealName != null ? res.data.bonusRealName : '分红';
          this.contributionRealName = res.data.contributionRealName != null ? res.data.contributionRealName : '贡献';
        } else {
          Toast.fail('加载失败');
        }
      })

      this.$get(this.apiName.textDescription, {
        appid: appid,
        mobile: mobile
      }).then(res => {
        if (res.code == '0000') {
          this.Introductions = res.data;
        }
        // console.log(res,"????")
      })

      this.$get(this.apiName.contributionInfo, {
        appid: appid,
        mobile: mobile
      }).then(res => {
        console.log(res);
        if (res.code == '0000') {
          this.dividendInformation.contribution = res.data.contribution;
          this.dividendInformation.frozenContribution = res.data.frozenContribution;
          this.dividendInformation.leaderFrozenContribution = res.data.leaderFrozenContribution;
          this.dividendInformation.leaderContributionIsOn = res.data.leaderContributionIsOn;
        }
      })

      this.loadingInstance = Loading.service();
      this.dataList(this.pagesNum, '')

    },
    methods: {
      Intercept(e) {
        var num = e.toString().match(/^\d+(?:\.\d{0,2})?/);
        return num[0];
      },
      returnBut() {
        this.$router.replace('/?token=' + localStorage.getItem('token'));
      },
      riskCli() {
        this.$router.replace('/?token=' + localStorage.getItem('token'));
        this.$store.state.stat = 1;
      },
      infon() {
        this.Introduction = true;
        setTimeout(() => {
          this.Introduction = false;
        }, 2000)
      },
      infoLock() {
        this.IntroductionLeaderLock = true;
        setTimeout(() => {
          this.IntroductionLeaderLock = false;
        }, 2000)
      },
      pagesClick() {
        var len = this.list[this.list.length - 1];
        // console.log(len)
        this.pagesNum = this.pagesNum + 1;
        this.dataList(this.pagesNum, len.key)
      },
      dataList(e, x) {
        this.$get(this.apiName.contributionRecord, {
          appid: appid,
          mobile: mobile,
          page: e,
          date: x
        }).then(res => {
          if (res.code == '0000') {
            // var str = res.data;
            // var arr = [];
            // var map = {};
            //
            // for (var i = 0;i < str.length; i++){
            //     var ai = str[i];
            //     var spl = ai.date.split('-');
            //     var month = spl[1]<=10?spl[1]:'0'+spl[1];
            //     var day = spl[2]>=10?spl[2]:'0'+spl[2];
            //     ai.date = month+'-'+day;
            //     if(!map[ai.date]){
            //         arr.push({
            //             key:ai.date,
            //             list:[ai]
            //         })
            //         map[ai.date] = ai;
            //     }else{
            //         for(var j = 0; j < arr.length; j++){
            //             var dj = arr[j];
            //             if(dj.key == ai.date){
            //                 dj.list.push(ai);
            //                 break;
            //             }
            //         }
            //     }
            // }

            // this.list = arr.reverse();
            if (res.data.length == 0) {
              this.pageStat = false;
              this.loadingInstance.close();
              Toast.fail('到底了...');
              return false;
            }
            this.loadingInstance.close();
            res.data.forEach((item, index) => {
              // item.value.reverse();
              item.date = item.key.substring(5);
              this.list.push(item)
            })
            // this.list = res.data;
          } else {
            Toast.fail('加载失败');
          }
        })
      }
    }
  }
</script>

<style scoped>
  .bg {
    width: 95%;
    margin: 0 auto;
    height: 200px;
    /*background: url("/static/images/bg.png") center no-repeat;*/
    /*background-size: 100% 100%;*/
    overflow: hidden;
    position: relative;
  }

  .returnBut {
    position: absolute;
    left: 10px;
    top: 16px;
    z-index: 99;
    display: flex;
    align-items: center;
  }

  .returnBut > img {
    width: 20px;
    height: 18px;
  }

  .returnBut > p {
    color: #ffffff;
    font-size: 16px;
  }

  .bacColor {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
  }

  .bg_con {
    width: 80%;
    display: flex;
    margin: 45px auto 24px;
    position: relative;
    justify-content: space-between;
  }
  .bg_con2{
    width: 80%;
    display: flex;
    margin: 0 auto;
    justify-content: space-around;
    margin-top: 50px
  }

  .infon {
    /*position: absolute;*/
    width: 15px;
    height: 15px;
    /*margin-top: 3px;*/
    margin-left: 3px;
  }

  .popBg {
    position: absolute;
    top: -35px;
    background: #ffffff;
    padding: 5px 8px;
    border-radius: 5px;
    border: 1px solid #ffffff;
    color: #000000;
    font-size: 12px;
    z-index: 100;
    right: -60px;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .popBg2 {
    position: absolute;
    top: -35px;
    background: #ffffff;
    padding: 5px 8px;
    border-radius: 5px;
    border: 1px solid #ffffff;
    color: #000000;
    font-size: 12px;
    z-index: 100;
    right: -20px;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .popBg > p {
    font-size: 10px;
  }

  .popBg > img {
    width: 15px;
    height: 15px;
    position: absolute;
    left: 195px;
    top: 20px;
    z-index: 12;
  }

  .popBg2 > img {
    width: 15px;
    height: 15px;
    position: absolute;
    left: 93px;
    top: 20px;
    z-index: 12;
  }

  .raiders {
    /*display: flex;*/
    width: 296px;
    font-size: 10px;
    text-align: left;
    margin: 0 auto 16px;
    color: rgba(255, 255, 255, .6);
    position: relative;
    z-index: 2;
  }

  .raiders > span:nth-child(2) {
    font-weight: bold;
  }

  .bg_con > div > p:nth-child(1) {
    color: #FFFFFF;
    font-size: 14px;
    margin-bottom: 10px;
    text-align: center;
  }

  .bg_con2 > div > div:nth-child(1) {
    color: #FFFFFF;
    font-size: 14px;
    margin-bottom: 10px;
    text-align: center;
  }

  .bg_con > div > p:nth-child(2) {
    color: #FFFFFF;
    font-size: 24px;
    font-family: FZCYJ;
    text-align: center;
  }

  .bg_con2 > div > div:nth-child(2) {
    color: #FFFFFF;
    font-size: 24px;
    font-family: FZCYJ;
    text-align: center;
    margin-bottom: 15px;
  }

  .withdraw {
    width: 72px;
    height: 32px;
    color: #2f80ed;
    background: #ecf4ff;
    border: none;
    border-radius: 16px;
    font-size: 16px;
    font-weight: 600;
    margin-left: 24px;
  }

  .listWrap {
    width: 95%;
    margin-top: 24px;
  }

  .list > h3 {
    font-size: 20px;
    font-family: FZCYJ;
    font-weight: bold;
    margin-left: 16px;
  }

  .uls > li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 15px 15px 15px;
    border-bottom: 1px solid #ebebeb;
  }

  .uls > li:last-child {
    border: none;
  }

  .ulsLiLeft > p:nth-child(1) {
    font-size: 16px;
    margin-bottom: 5px;
  }

  .ulsLiLeft > p:nth-child(2) {
    font-size: 14px;
    color: #878787;
  }

  .ulsRight > p:nth-child(1) {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    text-align: right;
  }

  .ulsRight > p:nth-child(2) {
    color: #2f80ed;
    font-size: 14px;
    text-align: center;
  }

  .noData {
    width: 80px;
    color: #878787;
    font-size: 16px;
    margin: 30px auto 50px;
    text-align: center;
  }

  .noData > img {
    width: 59px;
    height: 59px;
    display: block;
    margin: 0 auto;
    margin-bottom: 5px;
  }

  .load {
    width: 100%;
    height: 60px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/contribution/index.vue